<form [formGroup]="formData" *ngIf="formData && calendarTranslate">

  <div class="ui-g form-group master-data">
    <div [kv-form-element]="{label: 'customerDetail.civil_status', md: '4'}">
      <p-dropdown [options]="civilStatuses" formControlName="civil_status_id" [style]="{'width':'100%'}"></p-dropdown>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.relative_members', md: '4'}">
      <input type="number" min="0" pInputText formControlName="relative_members" />
    </div>
  </div>

  <div class="ui-g form-group master-data">
    <div class="ui-g-12">
      <hr />
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.mate_name', md: '4'}">
      <input type="text" pInputText formControlName="mate_name" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.mate_surname', md: '4'}">
      <input type="text" pInputText formControlName="mate_surname" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.sex', md: '4'}">

      <p-dropdown [options]="sessi" formControlName="mate_sex" name="sex"></p-dropdown>
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.mate_birth_place', md: '4'}">
      <input type="text" pInputText formControlName="mate_birth_place" />
    </div>
    <div [kv-form-element]="{label: 'customerDetail.mate_education', md: '4'}">
      <p-dropdown [options]="educations" formControlName="mate_education" [style]="{'width':'100%'}"></p-dropdown>
    </div>
    <div [kv-form-element]="{label: 'customerDetail.mate_employment', md: '4'}">
      <p-dropdown [options]="employments" formControlName="mate_employment" [style]="{'width':'100%'}"></p-dropdown>
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.mate_birthday', md: '4'}">
      <app-kv-calendar
        class="over"
        [inputName]="'mate_birthday'"
        [formData]="formData"
        [defaultDate]="formData.controls.mate_birthday.value"
        [defaultValue]="formData.controls.mate_birthday.value"
        [maxDate]="today"
        [yearRange]="'1900:2019'"
      ></app-kv-calendar>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.children_number', md: '4'}">
      <input type="number" pInputText formControlName="children_number" [min]="minChildren" [max]="maxChildren" />
    </div>

    <div class="ui-g-12 ui-g-nopad" *ngFor="let item of evaluateChildrenCount(); let i = index">
      <div class="ui-g-12">
        <hr />
      </div>

      <div [kv-form-element]="{ label: 'customerDetail.son_' + i, md: '12'}"></div>
      <div [kv-form-element]="{label: 'customerDetail.education', md: '3'}">
        <p-dropdown [options]="educations" [formControlName]="evaluateFormControlName(i)['education']" [style]="{ width: '100%' }"></p-dropdown>
      </div>
      <div [kv-form-element]="{label: 'customerDetail.employment', md: '3'}">
        <p-dropdown [options]="employments" [formControlName]="evaluateFormControlName(i)['employment']" [style]="{ width: '100%' }"></p-dropdown>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.birthday', md: '3'}">
        <p-calendar
          class="over"
          [showIcon]="true"
          [formControlName]="evaluateFormControlName(i)['birthday']"
          [readonlyInput]="false"
          [dateFormat]="calendarTranslate.dateFormat"
          [locale]="calendarTranslate"
          [maxDate]="today"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="'1900:2019'"
        ></p-calendar>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.sex', md: '3'}">
        <p-radioButton [name]="evaluateFormControlName(i)['sex']" [formControlName]="evaluateFormControlName(i)['sex']" value="M" [label]="'customerDetail.sex_male' | translate"></p-radioButton>
        <p-radioButton [name]="evaluateFormControlName(i)['sex']" [formControlName]="evaluateFormControlName(i)['sex']" value="F" [label]="'customerDetail.sex_female' | translate" ></p-radioButton>
        <p-radioButton [name]="evaluateFormControlName(i)['sex']" [formControlName]="evaluateFormControlName(i)['sex']" value="A" [label]="'customerDetail.sex_other' | translate"></p-radioButton>
      </div>
    </div>

  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/familyinfo/familyinfo.component.html